/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/
// Site key vars
// @todo: create admin interface to manage some of these options.

const DeliverTodayDist = 20; // (LF-253)
const DeliverPreOrderDist = 50; // Used as a check before checking postcodes
const DeliverPreOrderLutonDist = 50; // Used as a check before checking postcodes


// Current date and time
const now = new Date();
const current_day = now.getDate();
const current_month = now.toLocaleString('default', { month: 'long' });
const current_month_num = now.getMonth()+1;
const current_year = now.getFullYear();
const current_hours = now.getHours();
const current_minutes = now.getMinutes();
const current_wday = now.getDay();

// Permitted slots for delivery
const deliver_today_empty = [];
const deliver_today = ['4:00 PM - 6:00 PM','6:00 PM - 8:00 PM'];
const pre_order_empty = [];


// Delivery slots dictated in Buunto
let buuntoAvailableDeliverySlots = true;



// Default Liphook Hub
// Deliver limits in miles and accpted postcodes (Liphook: default, address: GU307DR)
const deliverFromLatitude = 51.071179;
const deliverFromLongitude = -0.801916;

const deliver_today_miles = 20; // (LF-253)
const deliver_pre_order_miles = 40;

const deliver_pre_order_pc_AA99_9AA = ["GU10","GU26","GU27","GU29","GU30","GU31","GU33","GU35","GU11","GU12","GU14","GU28","GU32","GU34","GU51","GU52","SO24","BN10","BN11","BN12","BN13","BN14","BN15","BN16","BN17","BN18","BN25","BN41","BN42","BN43","BN44","BN45","BN50","BN51","BN52","BN88","BN95","BN99","GU15","GU16","GU17","GU18","GU19","GU20","GU21","GU22","GU23","GU24","GU25","GU46","GU47","HP10","HP11","HP12","HP13","HP14","HP15","KT10","KT11","KT12","KT13","KT14","KT15","KT16","KT17","KT18","KT19","KT20","KT21","KT22","KT23","KT24","OX10","OX11","OX49","PO10","PO11","PO12","PO13","PO14","PO15","PO16","PO17","PO18","PO19","PO20","PO21","PO22","RG10","RG12","RG17","RG18","RG19","RG20","RG21","RG22","RG23","RG24","RG25","RG26","RG27","RG28","RG29","RG30","RG31","RG40","RG41","RG42","RG45","RH10","RH11","RH12","RH13","RH14","RH15","RH16","RH17","RH18","RH19","RH20","RH77","SL60","SL95","SO14","SO15","SO16","SO17","SO18","SO19","SO20","SO21","SO22","SO23","SO25","SO30","SO31","SO32","SO40","SO41","SO42","SO43","SO45","SO50","SO51","SO52","SO53","SO97","SP10","SP11","SW13","SW14","SW15","SW18","SW19","SW20","TN20","TN22","TW10","TW11","TW12","TW13","TW14","TW15","TW16","TW17","TW18","TW19","TW20"];
const deliver_pre_order_pc_AA9_9AA = ["SP1","SP2","GU8","GU9","GU1","GU2","GU3","GU4","GU7","BN1","BN2","BN3","BN5","BN6","BN7","BN8","BN9","CR4","CR5","GU5","GU6","HP7","HP8","HP9","KT1","KT2","KT3","KT4","KT5","KT6","KT7","KT8","KT9","PO1","PO2","PO3","PO4","PO5","PO6","PO7","PO8","PO9","RG1","RG2","RG4","RG5","RG6","RG7","RG8","RG9","RH1","RH2","RH3","RH4","RH5","RH6","RH7","RH8","RH9","SL0","SL1","SL2","SL3","SL4","SL5","SL6","SL7","SL8","SL9","SM1","SM2","SM3","SM4","SM5","SM6","SM7","SN8","SP4","SP5","SP6","SP9","TN2","TN7","TN8","TW1","TW2","TW9"];

const pre_order_low_days = ['11:00 AM - 1:00 PM','12:00 PM - 2:00 PM','1:00 PM - 3:00 PM','2:00 PM - 4:00 PM','3:00 PM - 5:00 PM','4:00 PM - 6:00 PM','5:00 PM - 7:00 PM'];
const pre_order_high_days = ['11:00 AM - 1:00 PM','12:00 PM - 2:00 PM','1:00 PM - 3:00 PM','2:00 PM - 4:00 PM','3:00 PM - 5:00 PM','4:00 PM - 6:00 PM','5:00 PM - 7:00 PM','6:00 PM - 8:00 PM'];


// HUBS: CONFIG START
// ------------------

// Luton postcodes, address: LU2 9LF
const deliver_pre_order_luton_miles = 40;
const deliverFromLutonLatitude = 51.874790;
const deliverFromLutonLongitude = -0.385160;

const deliver_pre_order_pc_luton_AA99_9AA = ["AL10","HP16","HP17","HP18","HP19","HP20","HP21","HP22","HP23","HP27","MK17","MK18","WD17","WD24","WD25","OX39","OX44","SG15", "SG16", "MK45", "SG17", "SG14", "SG13", "MK10", "MK15", "SG18", "MK14", "MK13", "MK42", "SG12", "MK43", "MK12", "MK16", "MK40", "SG10", "SG11", "SG19", "MK11", "MK19", "EN10", "MK46", "MK41", "EN11", "CM23", "NN12", "MK44", "OX26", "CM21", "OX27", "CM22", "OX25", "NN13", "OX20", "CM24", "OX17", "OX33", "OX16", "OX14", "OX15", "OX13", "CB11", "CM19", "CM20", "CM17"];
const deliver_pre_order_pc_luton_AA9_9AA = ["AL1","AL2","AL3","AL4","AL5","AL6","AL7","AL8","AL9","HP1","HP3","HP4","HP5","HP6","LU1","LU2","LU3","LU4","LU5","LU6","LU7","MK2","MK3","MK4","OX9","SG1","SG2","SG3","SG4","UB9","WD3","WD4","WD5","HP2","SG5", "SG6", "SG7", "MK7", "EN6", "MK1", "MK6", "MK9", "MK5", "MK8", "SG8", "SG9", "EN8", "EN7", "EN9", "NN7", "OX5", "OX2", "OX3", "OX4", "OX1"];

const pre_order_luton_low_days = ['12:00 PM - 2:00 PM','1:00 PM - 3:00 PM','2:00 PM - 4:00 PM','3:00 PM - 5:00 PM','4:00 PM - 6:00 PM','5:00 PM - 7:00 PM'];
const pre_order_luton_high_days = ['12:00 PM - 2:00 PM','1:00 PM - 3:00 PM','2:00 PM - 4:00 PM','3:00 PM - 5:00 PM','4:00 PM - 6:00 PM','5:00 PM - 7:00 PM','6:00 PM - 8:00 PM'];


// West postcodes
const deliver_pre_order_west_miles = 40;
const deliverFromWestLatitude = 51.544195;
const deliverFromWestLongitude = -1.767077;

const deliver_pre_order_pc_west_AA99_9AA = ["BH10","BH11","BH12","BH13","BH14","BH15","BH17","BH18","BH22","BH23","BH24","BH25","BH31"];
const deliver_pre_order_pc_west_AA9_9AA = ["BH1","BH2","BH3","BH4","BH5","BH6","BH7","BH8","BH9"];

const pre_order_west_low_days = ['12:00 PM - 2:00 PM','1:00 PM - 3:00 PM','2:00 PM - 4:00 PM','3:00 PM - 5:00 PM','4:00 PM - 6:00 PM','5:00 PM - 7:00 PM'];
const pre_order_west_high_days = ['12:00 PM - 2:00 PM','1:00 PM - 3:00 PM','2:00 PM - 4:00 PM','3:00 PM - 5:00 PM','4:00 PM - 6:00 PM','5:00 PM - 7:00 PM','6:00 PM - 8:00 PM'];



// Kent postcodes
const deliver_pre_order_kent_miles = 40;
const deliverFromKentLatitude = 51.287630;
const deliverFromKentLongitude = 0.254686;

const deliver_pre_order_pc_kent_AA99_9AA = ["BN20","BN21","BN22","BN23","BN24","ME14","ME15","ME16","ME18","ME19","ME20","SE25","TN10","TN11","TN12","TN13","TN15","TN16","TN17","TN18","TN19","TN21","TN32","TN33","TN39","TN40"];
const deliver_pre_order_pc_kent_AA9_9AA = ["BR2","BR3","BR4","BR5","BR6","BR7","BR8","CR0","CR2","CR3","CR6","CR7","CR8","DA3","DA4","ME6","TN1","TN3","TN4","TN5","TN6","TN9"];

const pre_order_kent_low_days = ['12:00 PM - 2:00 PM','1:00 PM - 3:00 PM','2:00 PM - 4:00 PM','3:00 PM - 5:00 PM','4:00 PM - 6:00 PM','5:00 PM - 7:00 PM'];
const pre_order_kent_high_days = ['12:00 PM - 2:00 PM','1:00 PM - 3:00 PM','2:00 PM - 4:00 PM','3:00 PM - 5:00 PM','4:00 PM - 6:00 PM','5:00 PM - 7:00 PM','6:00 PM - 8:00 PM'];

// ---------
// HUBS: END



const banBuntoDates = true; // Activate the function to ban certain dates within the date picker (up until a date)
const banBuntoDatesHub = 'Luton';
const banBuntoDatesUntil = '2025-3-26';

// Deliver today options
const deliverTodayWeekDays = [5,6]; // Sun = 0, Mon = 1...
let deliverTodayWeekDayPermitted = false;
if(deliverTodayWeekDays.includes(current_wday)) {
  deliverTodayWeekDayPermitted = true;
  if(current_hours > 13) { // shut-off at 2:00 (LF-253)
    deliverTodayWeekDayPermitted = false;
  }
}
  
// END: Site key vars
// -----------------------------------------------------------------------------*/









//
// Postcode list checker function
// ------------------------------
// - Checks for user inputted postcode data

// POSTCODE FORMATS
// AA9A 9AA
// A9A 9AA
// A9 9AA
// A99 9AA
// AA9 9AA
// AA99 9AA

window.checkPcList = function(pc) {
  let myHub = 'None';
  let pcList, pcLutonList, pcKentList, pcWestList, pcCheck = '';

  // Reset Buunto date if on the cart page
  if(typeof window.Buunto == 'object') {
    window.Buunto.datePicker.selectDate(undefined); 
  }

  // Clean up PC and note pattern
  pc = pc.replace(' ', '');
  pc = pc.toUpperCase();
  let pcSize = pc.length;

  if(pcSize == 7){
    pcList = deliver_pre_order_pc_AA99_9AA;
    pcLutonList = deliver_pre_order_pc_luton_AA99_9AA;
    pcKentList = deliver_pre_order_pc_kent_AA99_9AA;
    pcWestList = deliver_pre_order_pc_west_AA99_9AA;
    pcCheck = pc.substring(0, 4);
  }
  else if(pcSize == 6) {
    pcList = deliver_pre_order_pc_AA9_9AA;
    pcLutonList = deliver_pre_order_pc_luton_AA9_9AA;
    pcKentList = deliver_pre_order_pc_kent_AA9_9AA;
    pcWestList = deliver_pre_order_pc_west_AA9_9AA;
    pcCheck = pc.substring(0, 3);
  }
  else {
    if (supportsSessionStorage()) { 
      sessionStorage.setItem('delivery-hub', myHub);
    }
    return false;
  }

  // Assign Hub to storage
  if(pcList.includes(pcCheck)) {
    myHub = 'Liphook';
  }
  else if(pcLutonList.includes(pcCheck)) {
      myHub = 'Luton';
  }
  else if(pcKentList.includes(pcCheck)) {
      myHub = 'Kent';
  }
  else if(pcWestList.includes(pcCheck)) {
      myHub = 'West';
  }
  if (supportsSessionStorage()) { 
    sessionStorage.setItem('delivery-hub', myHub);
  }

  if(myHub != 'None'){
    return true;
  }
  else {
    return false;
  }
}


//
// Site wide functions
// -------------------
// - Perform some tasks based on the current template
document.addEventListener("DOMContentLoaded", function() {

  // Cart page, perform checks
  if (document.querySelector('body').classList.contains("template-cart")) {
    drawerChecks();
  }
  else if (document.querySelector('body').classList.contains("template-page-our-menu")) {
    // Trigger menu search results if need be
    searchResult();
  }
  
});


//
// Cart - watch for Pre Order events in the cart outside of an event page : trigger delete
function preOrderEventsInCart() {
  const body = document.querySelector('body');
  if(body && !body.classList.contains('template-product-lf-event-with-dishes')) {
    const cartItems = document.querySelectorAll('.cart__items .cart-item');
    if(cartItems) {
      for(let i=0; i<cartItems.length; i++) {
        if(cartItems[i].getAttribute('data-item-type') && cartItems[i].getAttribute('data-item-type') == "Event Bundle" ){
          const cartItemsRemove = cartItems[i].querySelector('.cart-item__remove');
          if(cartItemsRemove) {
            cartItemsRemove.click();
          }
        }
      }
    }
  }
}



//
// Search result - product
// -----------------------
// - Trigger open draw on menu page if arriving from a search result
function searchResult() {
  const urlParams = new URLSearchParams(window.location.search);
  const searchParam = urlParams.get('search-product-id');
  if(searchParam != null){
    const productCard = document.querySelector('product-card[data-product-id="'+searchParam+'"] a.product-card-btn__btn');
    if(productCard != null){
      productCard.click();
    }
  }
}


//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
//:::                                                                         :::
//:::  This routine calculates the distance between two points (given the     :::
//:::  latitude/longitude of those points). It is being used to calculate     :::
//:::  the distance between two locations using GeoDataSource (TM) prodducts  :::
//:::                                                                         :::
//:::  Definitions:                                                           :::
//:::    South latitudes are negative, east longitudes are positive           :::
//:::                                                                         :::
//:::  Passed to function:                                                    :::
//:::    lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)  :::
//:::    lat2, lon2 = Latitude and Longitude of point 2 (in decimal degrees)  :::
//:::    unit = the unit you desire for results                               :::
//:::           where: 'M' is statute miles (default)                         :::
//:::                  'K' is kilometers                                      :::
//:::                  'N' is nautical miles                                  :::
//:::                                                                         :::
//:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::

window.distance=function(lat1, lon1, lat2, lon2, unit){
    if ((lat1 == lat2) && (lon1 == lon2)) {
        return 0;
    }
    else {
        var radlat1 = Math.PI * lat1/180;
        var radlat2 = Math.PI * lat2/180;
        var theta = lon1-lon2;
        var radtheta = Math.PI * theta/180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180/Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit=="K") { dist = dist * 1.609344 }
        if (unit=="N") { dist = dist * 0.8684 }
        return dist;
    }
}


//
// Buunto check time slots (deliver today / deliver pre-order)
// -----------------------------------------------------------
// - This is used to manage the rules for time slot use
// - Deliver today slots
// - Deliver in the future slots
let bunntoPermittedSlots = [];
window.buuntoManageTimeSlots = (action) => {
  //console.log('buuntoManageTimeSlots - '+action)

  const timeOptions = document.querySelectorAll('.buunto-time-slot-picker-dropdown option');
  let t = null;
  let permitedSlots = [];
  
  if(timeOptions) {
    if (supportsSessionStorage()) { 
      autoAction = sessionStorage.getItem('filters--delivery');

      // Auto action might be null if session gone / deleted: get action from toggled buttons
      if(autoAction == null) {
        const selectedDeliveryOption = document.querySelector('.delivery-toggle .c-btn--primary');
        if(selectedDeliveryOption != null) {
          const deliveryOption = selectedDeliveryOption.getAttribute('data-filter-on');
          sessionStorage.setItem('filters--delivery', deliveryOption);
          autoAction = deliveryOption;
        }
        else {
          console.log('Warning - no delivery method stored, this may cause order issues.')
        }
      }
    }
    if(action == 'auto') {
      action = autoAction;
    }
    
    if(action == 'clear') {
      // Local delivery
      if(timeOptions.length > 0){
        for(let t=0; t<timeOptions.length; t++) {
          timeOptions[t].removeAttribute('disabled');            
        }
      }
    }
    // LF-236 Deliver today update
    // Now only available Fri + Sat
    else if(action == 'Deliver today'){
      console.log('Deliver today',deliverTodayWeekDays.includes(current_wday))
      if(deliverTodayWeekDays.includes(current_wday)) {
        permitedSlots = deliver_today;
        deliverTodayWeekDayPermitted = true;
        if(current_hours > 13) { // shut-off at 2:00 (LF-253)
          permitedSlots = [];
          deliverTodayWeekDayPermitted = false;
        }
      }
      else { 
        permitedSlots = deliver_today_empty;
      }
    }
    else if(action == 'Pre order') {
      let buuntoDeliveryDay = '';
      let deliveryDate = '';

      // Get delivery day from Buunto (it is held in a poor format for date use and requires manipulation)
      const buuntoInputDate = document.querySelector('.buunto-date-field input[name="attributes[Delivery Date]"]');
      if(buuntoInputDate){
        deliveryDate = buuntoInputDate.value;
        deliveryDate = deliveryDate.replace(",","");
        deliveryDate = deliveryDate.split(" ");
        deliveryDate = deliveryDate[1]+' '+deliveryDate[0].substring(0,3)+' '+deliveryDate[2]+' 00:00:00 GMT';
        const unixTime = new Date(Date.parse(deliveryDate));
        buuntoDeliveryDay = unixTime.getDay();
        // console.log("Delivery date",deliveryDate);
      }

      if(buuntoDeliveryDay == 1) {
        if (
          deliveryDate == "22 Dec 2025 00:00:00 GMT" ||
          deliveryDate == "31 Aug 2026 00:00:00 GMT"
        ) {
          // Exception pre-Christmas 2025
          permitedSlots = pre_order_low_days; // default
          if (supportsSessionStorage()) {
            if( sessionStorage.getItem('delivery-hub') == 'Luton') { 
              //permitedSlots = pre_order_empty; 
              permitedSlots = pre_order_luton_low_days; 
            }
            else if( sessionStorage.getItem('delivery-hub') == 'Kent') { 
              //permitedSlots = pre_order_empty; 
              permitedSlots = pre_order_kent_low_days;  
            }
            else if( sessionStorage.getItem('delivery-hub') == 'West') { 
              //permitedSlots = pre_order_empty;
              permitedSlots = pre_order_west_low_days;  
            }
          } 
        } else {
          // Mon - force empty
          permitedSlots = pre_order_empty; 
        }
          // // Mon - force empty
          // permitedSlots = pre_order_empty; 
      }
      else if(buuntoDeliveryDay == 2) {
        // Tue
        permitedSlots = pre_order_low_days; // default
        if (supportsSessionStorage()) {
          if( sessionStorage.getItem('delivery-hub') == 'Luton') { 
            //permitedSlots = pre_order_empty; 
            permitedSlots = pre_order_luton_low_days; 
          }
          else if( sessionStorage.getItem('delivery-hub') == 'Kent') { 
            //permitedSlots = pre_order_empty; 
            permitedSlots = pre_order_kent_low_days;  
          }
          else if( sessionStorage.getItem('delivery-hub') == 'West') { 
            //permitedSlots = pre_order_empty;
            permitedSlots = pre_order_west_low_days;  
          }
        } 
      }
      else if(buuntoDeliveryDay == 3) {
        // Wed
        permitedSlots = pre_order_low_days; // default
        if (supportsSessionStorage()) {
          if(sessionStorage.getItem('delivery-hub') == 'Luton') { 
            permitedSlots = pre_order_luton_low_days; 
          }
          else if( sessionStorage.getItem('delivery-hub') == 'Kent') { 
            permitedSlots = pre_order_kent_low_days;  
          }
          else if( sessionStorage.getItem('delivery-hub') == 'West') { 
            permitedSlots = pre_order_west_low_days;  
          }
        } 
      }
      else if(buuntoDeliveryDay == 0) {
        // Sun
        permitedSlots = pre_order_low_days; // default
        if (supportsSessionStorage()) {
          if(sessionStorage.getItem('delivery-hub') == 'Luton') { 
            //permitedSlots = pre_order_empty; 
            permitedSlots = pre_order_luton_low_days; 
          }
          else if( sessionStorage.getItem('delivery-hub') == 'Kent') { 
            //permitedSlots = pre_order_empty; 
            permitedSlots = pre_order_kent_low_days;  
          }
          else if( sessionStorage.getItem('delivery-hub') == 'West') { 
            //permitedSlots = pre_order_empty;  
            permitedSlots = pre_order_west_low_days;  
          }
        } 
      }
      else { 
        // All other days 
        permitedSlots = pre_order_high_days; // default
        if (supportsSessionStorage()) {
          if(sessionStorage.getItem('delivery-hub') == 'Luton') { 
            permitedSlots = pre_order_luton_high_days; 
          }
          else if( sessionStorage.getItem('delivery-hub') == 'Kent') { 
            permitedSlots = pre_order_kent_high_days;  
          }
          else if( sessionStorage.getItem('delivery-hub') == 'West') { 
            permitedSlots = pre_order_west_high_days;  
          }
        } 
      }
    }
    
    // Restrict slot options
    //console.log(permitedSlots)
    const pickups = document.querySelectorAll('.buunto-combo-box-option');
    
    if(action !== 'clear' && pickups.length < 1) {
      for(t=1; t<timeOptions.length; t++) {
        if(permitedSlots.length == 0) {
          timeOptions[t].setAttribute('disabled', 'disabled');            
        }
        else if(!permitedSlots.includes(timeOptions[t].value)) {
          timeOptions[t].setAttribute('disabled', 'disabled');            
        }
      }

      bunntoPermittedSlots = permitedSlots; // Used on the cart page for signposting
    }

    // Finally check options against the time slot limits
    if(store_availability) {
      for(let sa=0; sa<store_availability.length; sa++) {
        let slot = store_availability[sa].formatted;
        let timeOption = document.querySelector('.buunto-time-slot-picker-dropdown option[value="'+slot+'"]');
        if(timeOption) {
          timeOption.setAttribute('data-store-availability-sold-out',store_availability[sa].soldOut);
          if(store_availability[sa].soldOut == true) {
            timeOption.setAttribute('disabled', 'disabled');            
          } 
        }
      }
    } 
  }

  // Update the time select label
  // - LF decided not to impliment just yet
  // const slotLabel = document.querySelector('.buunto-time-slot-picker-label');
  // if(slotLabel) {
  //   if(permitedSlots.length == 0){
  //     slotLabel.classList.add('no-slots');
  //   }
  //   else {
  //     slotLabel.classList.remove('no-slots');
  //   }
  // }

  // Reveal the date picker options 
  setTimeout(() => {
    const cartControls = document.querySelector('.cart__aside');
    if(cartControls) {
      cartControls.classList.remove('date-loading');
    }
  }, "100");
}


//
// Simple session storage test
// ---------------------------
const supportsSessionStorage = () => {
  try {
    return 'sessionStorage' in window && window['sessionStorage'] !== null;
  } catch(e) {
    return false;
  }
}

//
// Local storage test
// ------------------
const supportsLocalStorage = () => {
  try {
    return 'localStorage' in window && window['localStorage'] !== null;
  } catch(e) {
    return false;
  }
}

//
// Check cart and drawer actions
// -----------------------------
// - This runs whenever a draw opens, pdp, cart, filters, mob menu etc.
// - Is used to manipulate the contents
window.drawerChecks=function(){
  //console.log('checking for drawer load')
  
  let deliveryType = ''
  if (supportsSessionStorage()) { 
    deliveryType = sessionStorage.getItem('filters--delivery');
  }
  
  // Product drawer
  // Limit qty input items if deliver today
  setTimeout(() => {
    preOrderEventsInCart();

    if(deliveryType == 'Deliver today'){
      let qtyInput = document.querySelector('.mfp-quick-shop quick-shop .product-form__qty-input input');
      let qtyInputBtns = document.querySelectorAll('.mfp-quick-shop quick-shop .product-form__qty-input button');
      if(qtyInput) {
        let deliverTodayMax = qtyInput.getAttribute('data-deliver-today-max');
        if(deliverTodayMax >= 0 && deliverTodayMax != ''){
          
          qtyInput.addEventListener('change', function(event){
            if(qtyInput.value > deliverTodayMax) {
              qtyInput.value = deliverTodayMax;
            }
          });
          
          for(let b=0; b<qtyInputBtns.length; b++) {
            qtyInputBtns[b].addEventListener('click', function(event){
              if(qtyInput.value > deliverTodayMax) {
                qtyInput.value = deliverTodayMax;
              }
            });
          }
        }
      }
    }
    else {
      let qtyInput = document.querySelector('.mfp-quick-shop quick-shop .product-form__qty-input input');
      if(qtyInput) {
        //qtyInput.max = '';
      }
    }
  }, 100);
  

  // Cart drawer or cart page
  // Clear previous errors from cart
  let cartErrorDeliverToday = false;
  let proceedButton = document.querySelector('#drawer-cart a.cart__view');

  let cartItemsError = document.querySelectorAll('.cart-item.deliver-today-error');
  let cartControls = document.querySelector('.cart__controls');

  let cartPageBuuntoOptions = document.querySelectorAll('.buunto-method-picker label');
  let cartPageBuuntoOptionsWrapper = document.querySelector('.buunto-method-picker');

  let cartItems = document.querySelectorAll('.cart-item');
  
  // 
  // Clear previous checks
  if(proceedButton != null){
    proceedButton.removeAttribute('disabled');
  }
  if(cartControls != null){
    cartControls.classList.remove('disabled');
  }
  for(let e=0; e<cartItemsError.length; e++) {
    cartItemsError[e].classList.remove('deliver-today-error');
  }
  for(let b=0; b<cartPageBuuntoOptions.length; b++) {
    cartPageBuuntoOptionsWrapper.classList.remove('hide');
  }

  //
  // Campaign Data Capture Triggers
  setTimeout(() => {
    //console.log('Launch test:', document.querySelector('.mfp-cart-draw.mfp-wrap.mfp-ready'))
    if(document.querySelector('.mfp-cart-draw.mfp-wrap.mfp-ready')) { // Cart draw test
      
      if (supportsSessionStorage()) { 
        customerDataCapture = sessionStorage.getItem('customer-data-capture');
        
        if(customerDataCapture == 'true') {
          customerDataCaptureTag = sessionStorage.getItem('customer-tag');
          //console.log('Launch data capture for:', customerDataCaptureTag)
    
          const popupForm = document.querySelector('.promo-pop--lf-data');
          if(popupForm){
            popupForm.classList.add('js-active');
            const popupFormTagInput = document.getElementById('popupCustomerTags');
            if(popupFormTagInput) {
              popupFormTagInput.value = customerDataCaptureTag;
            }
          }
          
          // Clear data capture items - prevent further triggers
          sessionStorage.removeItem("customer-tag");
          sessionStorage.removeItem("customer-data-capture");
        }
      }
    }
  }, 500);
  
  //
  // Meal points
  /*
  let mealPoints = 0;
  for(let m=0; m<cartItems.length; m++) {
    let mealP = parseInt(cartItems[m].getAttribute('data-meal-points'));
    let q = cartItems[m].querySelector('input');
    if(q != null){
      mealP = mealP * q.value;
    }
    mealPoints = mealPoints + mealP;
  }
  let mealPointsIndex = 0;
  let mealClass = ''

  if(mealPoints > 9 && mealPoints < 16) {
    mealPointsIndex = 1;
  }
  else if(mealPoints > 15 && mealPoints < 21) {
    mealPointsIndex = 2;
    mealClass = 'twoP'
  }
  else if(mealPoints > 20) {
    mealPointsIndex = Math.ceil(mealPoints/10);
    if(mealPoints < 30){
      mealClass = 'twoP'
    }
    else {
      mealClass = 'threeP'
    }
  }

  console.log('Meal points: '+mealPoints)

  // Get the appropriate message
  mpText = ['', 'perfect for one', 'perfect for one to two', 'perfect for two', 'perfect for three', 'perfect for four']
  
  let mpTextOutput = 'perfect for lots';
  if(mealPointsIndex < mpText.length) {
    mpTextOutput = mpText[mealPointsIndex]
  }
  
  let mealPointsWrapper = document.getElementById('mealPoints');
  if(mealPointsWrapper != null) {
    if(mealPoints > 9) {
      mealPointsWrapper.classList.remove('twoP');
      mealPointsWrapper.classList.remove('threeP');
      mealPointsWrapper.classList.add('show');
      mealPointsWrapper.querySelector('span').innerHTML = mpTextOutput;
      if(mealClass != ''){
        mealPointsWrapper.classList.add(mealClass);
      }
    }
    else {
      mealPointsWrapper.classList.remove('show');
      mealPointsWrapper.classList.remove('twoP');
      mealPointsWrapper.classList.remove('threeP');
      mealPointsWrapper.querySelector('span').innerHTML = '';
    }
  }
  */
  
  // 
  // Check items if deliver today and limit the qty + button
  if(deliveryType == 'Deliver today'){
    //
    // Check if deliver today is an option?
    let deliverTodayBtn = document.querySelector('.delivery-toggle .c-btn[data-filter-on="Deliver today"]');
    if(!deliverTodayBtn) {
      if (supportsSessionStorage()) { 
        sessionStorage.setItem('filters--delivery', 'Pre order');
      }
      return;
    }

    if(cartPageBuuntoOptions) {
      // Buunto - force local delivery
      for(let b=0; b<cartPageBuuntoOptions.length; b++) {
        let methodName = cartPageBuuntoOptions[b].querySelector('.buunto-method-name').innerHTML;
        if(methodName == 'Local delivery') {
          cartPageBuuntoOptions[b].click();
        }
        else {
          cartPageBuuntoOptionsWrapper.classList.add('hide');
        }
      }
      buuntoManageTimeSlots('Deliver today');
    }
    
    // Cart item checks
    for(let c=0; c<cartItems.length; c++) {
      let cartQtyInput = cartItems[c].querySelector('.cart-item__qty input');
      
      if(cartQtyInput) {
        let deliverTodayMaxCart = parseInt(cartItems[c].getAttribute('data-deliver-today-stock'));
        
        if(deliverTodayMaxCart >= 0){
          cartQtyInput.setAttribute('max',deliverTodayMaxCart);
          let currentCartValue = parseInt(cartQtyInput.value);

          if(currentCartValue > deliverTodayMaxCart){
            cartErrorDeliverToday = true;
            cartItems[c].classList.add('deliver-today-error')
            let itemError = cartItems[c].querySelector('.cart-item__error')
            if(deliverTodayMaxCart < 1) {
              itemError.innerHTML = 'Not available for delivery today'
            }
            else {
              itemError.innerHTML = 'Only '+deliverTodayMaxCart+' available for delivery today'
            }
          }
          else {
            cartItems[c].classList.remove('deliver-today-error')
          }
        }
      }
    }    
  }
  else {
    if(cartPageBuuntoOptions) {
      // Make all time slots available
      buuntoManageTimeSlots('clear');
      buuntoManageTimeSlots('Pre order');
    }
  }
  
  //
  // Cart Errors - disable buttons
  if(cartErrorDeliverToday == true){
    if(proceedButton != null){
      proceedButton.setAttribute('disabled','disabled');
    }
    if(cartControls != null){
      cartControls.classList.add('disabled');
    }
  }
  else {
    if(proceedButton != null){
      proceedButton.removeAttribute('disabled','disabled');
    }
    if(cartControls != null){
      cartControls.classList.remove('disabled');
    }
  }

};


//
// Buunto ban orders until date
// -----------------------------------------------------------
// - Used to kill dates for a particular hub until a certain date
// @todo:
// - Clear dates when the PC changes
// - Check for date selected earlier than permitted
window.buuntoDisableDates = (hub, until) => {
  if (supportsSessionStorage()) { 
    if(hub == sessionStorage.getItem('delivery-hub')) { // Check we have the correct hub
      if(until){
        let untilDate = new Date(until);
        if(untilDate > now) { // Check that the until date is in the future
          if(typeof window.Buunto == 'object') {
            // Attempt to calculate what days should be turned off
            //window.Buunto.datePicker.selectDate(until) // not working 
            const allDatesToBan = document.querySelectorAll('.buuntoCal-day.buuntoCal-available');
            const datePickerMonth = document.querySelector('.buuntoCal-month');
            if(datePickerMonth) {
              let datePickerMonthText = datePickerMonth.innerHTML;
              datePickerMonthText = datePickerMonthText.split(' ');
              const datePickerMonthTextValue = datePickerMonthText[0];
              const datePickerYearTextValue = datePickerMonthText[1];
              const untilYear = untilDate.getFullYear();
              const untilMonth = untilDate.toLocaleString('default', { month: 'long' });
              const untilMonthNum = untilDate.getMonth()+1;
              const untilDay = untilDate.getDate();

              // Get the numerical month from the text month in the date picker
              const datePickerFantomDate = new Date(datePickerMonthTextValue+' 1, 2022');
              let datePickerMonthNum = 13;
              if (!isNaN(datePickerFantomDate)) {
                datePickerMonthNum = datePickerFantomDate.getMonth() + 1;
              }

              // Disable days that fall before the until date
              if(datePickerMonthTextValue == untilMonth) { // Date picker: Current month with until date
                for(let d=0; d<allDatesToBan.length; d++) {
                  const bDay = parseInt(allDatesToBan[d].querySelector('.buuntoCal-date').innerHTML);
                  if(bDay < untilDay) {
                    allDatesToBan[d].classList.add('disable');
                    if(allDatesToBan[d].classList.contains('buuntoCal-selected')) window.Buunto.datePicker.selectDate(until) // Auto select the earliest possible date
                  }
                }
              }
              else if(parseInt(datePickerYearTextValue) < untilYear) { // Date picker: Browsing the pre until date year so ban all
                for(let d=0; d<allDatesToBan.length; d++) {
                  allDatesToBan[d].classList.add('disable');
                  if(allDatesToBan[d].classList.contains('buuntoCal-selected')) window.Buunto.datePicker.selectDate(until) // Auto select the earliest possible date
                }
              }
              else if(datePickerMonthNum < untilMonthNum) { // Date picker: Browsing prev month to until date so ban all
                for(let d=0; d<allDatesToBan.length; d++) {
                  allDatesToBan[d].classList.add('disable');
                  if(allDatesToBan[d].classList.contains('buuntoCal-selected')) window.Buunto.datePicker.selectDate(until) // Auto select the earliest possible date
                }
              }
            }
          }
        }
      }
    }
  }
}